import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <header className="site-header">
      <div className="header-container">
        <Link to="/" className="logo">
          <span className="logo-text">Maître Dia</span>
        </Link>

        <nav className={`nav-menu ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link to="/" onClick={() => setMobileMenuOpen(false)}>ACCUEIL</Link>
          <a href="/#about" onClick={() => setMobileMenuOpen(false)}>À PROPOS</a>
          <a href="/#services" onClick={() => setMobileMenuOpen(false)}>SERVICES</a>
          <Link to="/temoignages" onClick={() => setMobileMenuOpen(false)}>TÉMOIGNAGES</Link>
          <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>CONTACT</Link>
        </nav>

        <div className="header-actions">
          <a href="tel:+32465619411" className="phone-btn">
            <Phone size={18} />
            <span>04 65 61 94 11</span>
          </a>
          
          <button 
            className="mobile-menu-toggle"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Header;
